import { render } from "./coaches-list.vue?vue&type=template&id=f4009270"
import script from "./coaches-list.vue?vue&type=script&lang=js"
export * from "./coaches-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__